export default __webpack_public_path__ + "static/media/fundusze.960e4e46.png";